import React from "react";
import {
  Modal,
  Text,
  Button,
  Title,
  Stack,
  Group,
  ThemeIcon,
} from "@mantine/core";
import { IconGift, IconConfetti } from "@tabler/icons-react";
import { Colors } from "../../Lib/Data";
import { useNavigate } from "react-router-dom";

interface WelcomeOfferModalProps {
  opened: boolean;
  onClose: () => void;
}

const WelcomeOfferModal: React.FC<WelcomeOfferModalProps> = ({
  opened,
  onClose,
}) => {
  const navigate = useNavigate();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      size="md"
      withCloseButton={false}
      padding={0}
      radius="lg"
      overlayProps={{
        opacity: 0.55,
        blur: 3,
      }}
    >
      <div
        style={{
          background: `linear-gradient(135deg, ${Colors.BlueSecondary} 0%, ${Colors.BluePrimary} 100%)`,
          padding: "2rem",
          borderRadius: "var(--mantine-radius-lg)",
          color: "white",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative Background Elements */}
        <div
          style={{
            position: "absolute",
            top: -20,
            right: -20,
            fontSize: "8rem",
            opacity: 0.1,
            transform: "rotate(15deg)",
          }}
        >
          🎁
        </div>
        <div
          style={{
            position: "absolute",
            bottom: -30,
            left: -30,
            fontSize: "6rem",
            opacity: 0.1,
            transform: "rotate(-15deg)",
          }}
        >
          ✨
        </div>

        <Stack
          align="center"
          gap="md"
          style={{ position: "relative", zIndex: 1 }}
        >
          <ThemeIcon
            size={60}
            radius="100%"
            variant="white"
            color="blue"
            style={{ fontSize: 32 }}
          >
            🎉
          </ThemeIcon>

          <Title order={2} style={{ color: "white", lineHeight: 1.2 }}>
            Welcome to Manysubs!
          </Title>

          <Text
            size="lg"
            fw={500}
            style={{ color: "rgba(255, 255, 255, 0.9)" }}
          >
            Unlock Huge Savings! 🚀
          </Text>

          <div
            style={{
              background: "rgba(255, 255, 255, 0.15)",
              padding: "1rem",
              borderRadius: "8px",
              border: "1px solid rgba(255, 255, 255, 0.3)",
            }}
          >
            <Text size="md" style={{ color: "white" }}>
              Subscribe for <span style={{ fontWeight: 800 }}>1 Year</span> and
              get{" "}
              <span
                style={{
                  fontWeight: 800,
                  color: "#FFD43B", // Gold color for emphasis
                  textTransform: "uppercase",
                }}
              >
                1 Extra Month FREE!
              </span>
            </Text>
          </div>

          <Group justify="center" mt="md" w="100%">
            <Button
              size="md"
              radius="md"
              variant="white"
              color="dark"
              fullWidth
              onClick={() => {
                onClose();
                navigate("/d/services");
              }}
              styles={{
                root: {
                  color: Colors.BluePrimary,
                  fontWeight: 700,
                },
              }}
            >
              Explore Offers
            </Button>
            <Button
              size="md"
              radius="md"
              variant="subtle"
              color="gray"
              fullWidth
              onClick={onClose}
              style={{ color: "rgba(255, 255, 255, 0.7)" }}
            >
              Maybe Later
            </Button>
          </Group>
        </Stack>
      </div>
    </Modal>
  );
};

export default WelcomeOfferModal;
